import WorkflowNav from './WorkflowNav';

export default WorkflowNav;



// WEBPACK FOOTER //
// ./src/Components/Main/Sidebar/WorkflowNav/index.tsx